import { GET_TOKEN, LOGGED_IN, LOGOUT, UPDATE_TOKEN } from "app/utils/constants/authActions";

const INIT_STATE = {
    auth: false,
    accessToken: null
}

const authReducer = (state = INIT_STATE, action) => {
    switch(action.type) {
        case LOGGED_IN: {
            return{
                ...state,
                auth: true,
                accessToken: action.payload
            }

        }
        case UPDATE_TOKEN: {
            
            return{
                ...state,
                accessToken: action.payload
            }

        }

        case LOGOUT: {
            return {
                ...state,
                auth: false,
                accessToken: null
            }
        }
        case GET_TOKEN: {
            
            return{
                ...state,
                accessToken: action.payload
            }

        }
        default: {
            return state;
        }
    }
}

export default authReducer